import React, { useEffect, useState } from 'react';
import axios from 'axios';

export const AccountForm = () => {
  const [accountData, setAccountData] = useState({});
  const [agencies, setAgencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
//  Fetch account data and agencies when component mounts
    Promise.all([
      axios.get('https://travelmidwest.com/lmiga/admin/account.json'),
      axios.get('https://travelmidwest.com/lmiga/admin/agencies.json')
    ]).then(([accountRes, agenciesRes]) => {
      setAccountData(accountRes.data.data);
      setAgencies(agenciesRes.data.data);
      setLoading(false);
    }).catch(err => {
      setError(err.response?.data?.error || { message: 'An error occurred' });
      setLoading(false);
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://travelmidwest.com/lmiga/admin/account.json', accountData);
      setAccountData(response.data.data);
      alert('Account updated successfully!');
    } catch (err) {
      setError(err.response?.data?.error || { message: 'An error occurred' });
    }
  };
}